import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getOrderReviews = async ({
  currentPage,
  itemPerPage,
  serviceId,
}) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `review/list?serviceId=${serviceId}&pageNumber=${currentPage}&itemPerPage=${itemPerPage}`,
    });
  } catch (error) {
    //message.error(error?.data?.message);
  }
};
export const deleteReview = async (id) => {
  try {
    return await internalApi.delete({
      server: "api/v1/",
      path: `admin/review/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
